import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { select } from '../@tix02/utility/dom';
gsap.registerPlugin(ScrollTrigger);


export default () => {
	const works = select('.work').all();
	const deltaThumb = 10;
	const deltaContent = 20;
	
	works.forEach(work => {
		const content = select('.w--inner', work).first;
		const thumb = select('.w--thumbnail', work).first;
		
		gsap.fromTo(thumb, { yPercent: deltaThumb, opacity:.75 }, {
			yPercent: deltaThumb * -1,
			opacity:1,
			ease: 'none',
			scrollTrigger: {
				trigger: work,
				scrub: true,
			}, 
		});
		
		gsap.fromTo(content, { yPercent: deltaContent }, {
			yPercent: deltaContent * -1,
			ease: 'none',
			scrollTrigger: {
				trigger: work,
				scrub: true,
			}, 
		});
	});
};
